import { defineMessages } from "react-intl";

export default defineMessages({
  cash: {
    id: "paymentMethods.cash",
    defaultMessage: "Cash",
  },
  allTransactionsWithServiceProvidersHaveToBeProcessedByRingTwice: {
    id: "choosePreferredPaymentMethod.allTransactionsWithServiceProvidersHaveToBeProcessedByRingTwice",
    defaultMessage:
      "<bold>All transactions</bold> with service providers have to be processed by Ring twice to ensure the quality and legality of the service. <break></break><break></break> It is <bold>not possible</bold> to pay Ring Twice service providers in cash.",
  },
  noCash: {
    id: "choosePreferredPaymentMethod.noCash",
    defaultMessage: "No cash",
  },
});
